import { render, staticRenderFns } from "./OrderShippingCard.vue?vue&type=template&id=75e228b4&"
import script from "./OrderShippingCard.vue?vue&type=script&lang=js&"
export * from "./OrderShippingCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderShippingCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports